// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifos.mobile.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.Suppress
import kotlinx.coroutines.flow.Flow
import org.mifos.mobile.core.model.entity.notification.NotificationRegisterPayload
import org.mifos.mobile.core.model.entity.notification.NotificationUserDetail

@OptIn(InternalKtorfitApi::class)
public class _NotificationServiceImpl(
  private val _ktorfit: Ktorfit,
) : NotificationService {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override fun getUserNotificationId(clientId: Long): Flow<NotificationUserDetail> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "device/registration/client/${"$clientId".encodeURLPath()}")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<NotificationUserDetail>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override suspend fun registerNotification(payload: NotificationRegisterPayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "device/registration")
        }
        setBody(payload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun updateRegisterNotification(id: Long, payload: NotificationRegisterPayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("PUT")
        url{
        takeFrom(_ktorfit.baseUrl + "device/registration/${"$id".encodeURLPath()}")
        }
        setBody(payload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }
}

public class _NotificationServiceProvider : ClassProvider<NotificationService> {
  override fun create(_ktorfit: Ktorfit): NotificationService = _NotificationServiceImpl(_ktorfit)
}

public fun Ktorfit.createNotificationService(): NotificationService = _NotificationServiceImpl(this)
